import script from "./AddSearchFamilyMember.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSearchFamilyMember.vue?vue&type=script&setup=true&lang=js"

import "./AddSearchFamilyMember.vue?vue&type=style&index=0&id=6ebafec0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ebafec0"]])

export default __exports__